import { selectTagVariant } from 'Config/configSlice';
import { useAppSelector } from 'Store';

import { TagVariant } from '@config/tagsConfig';

import type { CourseModel } from '../../data';

import { CourseStatusChips } from './course-status-chips';

type Props = {
  course: CourseModel | any;
};

export const CourseTagsDisplay = ({ course }: Readonly<Props>) => {
  const tagVariant = useAppSelector(selectTagVariant);

  if (tagVariant === TagVariant.NONE) {
    return null;
  }

  return <CourseStatusChips course={course} variant={tagVariant} />;
};
